import { newsApi } from './api';
import {
    ADD_JOB_ENDPOINT, API_BASE_URL, EXTRACT_JOB_DOCUMENT_ENDPOINT, GET_COMPLETED_JOB_ENDPOINT,
    GET_JOB_ENDPOINT,
    GET_JOB_STAS_ENDPOINT,
    JOB_EDIT_ENDPOINT,
    REMOVE_JOB_ENDPOINT
} from "./apiConstant";

export const JobService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getJobStatis: build.query({
            query: (id) => ({
                url: `${GET_JOB_STAS_ENDPOINT}/${id ? id : 0}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getInvoice: build.query({
            query: ({ id }) => ({
                url: `driver/invoice/${id ? id : ''}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getJob: build.query({
            query: ({ id, pagination }) => ({
                url: `${GET_JOB_ENDPOINT}/${id ? id : 0}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getCompletedJob: build.query({
            query: ({ id, pagination }) => ({
                url: `${GET_COMPLETED_JOB_ENDPOINT}${id ? id : ''}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        viewJob: build.query({
            query: ({ id }) => ({
                url: `driver-jobs/view/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        // ${API_BASE_URL?.split('api/')?.join('')}
        statusPaid: build.mutation({
            query: (id) => ({
                url: `driver-jobs/payment-mark-as-paid/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        addJob: build.mutation({
            query: (form) => ({
                url: `${ADD_JOB_ENDPOINT}`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        extractDocument: build.mutation({
            query: (form) => ({
                url: `${EXTRACT_JOB_DOCUMENT_ENDPOINT}`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: [],
        }),
        editJob: build.mutation({
            query: ({ id, newForm }) => ({
                url: `${JOB_EDIT_ENDPOINT}/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeJob: build.mutation({
            query: (id) => ({
                url: `${REMOVE_JOB_ENDPOINT}/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetJobStatisQuery,
    useGetJobQuery,
    useGetInvoiceQuery,
    useGetCompletedJobQuery,
    useViewJobQuery,
    useStatusPaidMutation,
    useAddJobMutation,
    useExtractDocumentMutation,
    useEditJobMutation,
    useRemoveJobMutation,
} = JobService